/** @jsx jsx */
import { React } from 'react';
import { jsx } from '@emotion/core';
import { Column, Container, Row } from '../../../styles/Grid';

import DotComponent from '../../ui/DotComponent';
import * as styles from './index.style';
import Spacer from '../../ui/Spacer';
import { SafePureComponent } from '../../../utils/SafePureComponent';

import Branded from './branded.svg';
import { get } from 'lodash';

class HighlightsModule extends SafePureComponent {
  renderBlock = (imgSrc, title) => {
    return (
      <div>
        <div className="textsec">{title}</div>
      </div>
    );
  };

  getColumnConfig = itemCount => {
    if (itemCount === 3) {
      return { lg: 4, md: 4, sm: 4 };
    }
    return { lg: 3, md: 2 };
  };

  getClassName = itemCount => {
    return 'have-' + itemCount + '-item';
  };

  render() {
    const { fields } = this.props;

    const Title = get(fields, 'Title', '');
    const SelectedHighlights = get(fields, 'SelectedHighlights', []);

    const itemCount = SelectedHighlights.length;
    return (
      <Spacer customCss={styles.containerSizesTop}>
        <Container css={[styles.itemsContainerCss]}>
          <h2>
            {Title.value}
            <DotComponent />
          </h2>

          <Row className={`boxmain ` + this.getClassName(itemCount)}>
            {SelectedHighlights.map((item, index) => {
              const Headline = item.fields.Headline;
              const SubHeading = item.fields.SubHeading;
              const Text = item.fields.Text;
              return (
                <Column
                  key={index}
                  className="commonbox"
                  cols={this.getColumnConfig(itemCount)}
                >
                  <div className="innerbox">
                    <h3>{Headline.value}</h3>
                    {this.renderBlock(Branded, SubHeading.value)}
                    <span className="hrline">
                      <hr className="seperator" />
                    </span>
                    <p>{Text.value}</p>
                  </div>
                </Column>
              );
            })}
          </Row>
        </Container>
      </Spacer>
    );
  }
}

export default HighlightsModule;
